<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">系统管理</li>
      </ul>
    </div>-->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 关联用户
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="back">返回上一级</button>
          <button class="GreenSmBtn" @click="addNew">新增</button>
          <!-- <button class="OrangeSmBtn" @click="reset">重置</button> -->
        </div>
        <div class="groupName">已关联用户组：{{groupName}}</div>
        <!-- <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl"></searchForm>
          <el-form ref="seefrom" class="uLabelDcontent" :model="seefrom">
            <el-form-item label="用户组名称:">
              <el-input placeholder="请输入用户组名称" v-model="seefrom.name"></el-input>
            </el-form-item>
          </el-form>
        </div>-->

        <div class="tableWrapper" v-loading="!showTable">
          <el-table :data="tableData" class="stripeTable" style="width: 100%">
            <el-table-column label="用户名" prop="name"></el-table-column>
            <el-table-column label="手机" prop="phone"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-link
                  icon="iconfont icondelete"
                  type="text"
                  size="small"
                  @click="deleteUser(scope.$index, scope.row)"
                >从组中删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <!-- 后端分页 -->
          <!-- <easyTable
            apiUrl="operation/group/users"
            :parent="self"
            :config="config"
            :other="other"
            ref="concatUsers"
          >
            <template slot="last">
              <el-table-column label="操作" width="400" align="center">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteUser(scope.$index, scope.row)"
                  >从组中删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable> -->
        </div>
        <el-dialog class="editDialog" :visible.sync="displayFormEdit" title="新增关联用户">
          <el-form :model="concatUser" ref="concatUser">
            <el-form-item label="请选择关联用户" prop="value">
              <el-select
                v-model="concatUser.value"
                filterable
                placeholder="请选择"
                style="float:right"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="displayFormEdit = false">取消</el-button>
            <el-button class="confirmConcat" type="primary" @click="addConcat">确定关联</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";
import { Loading } from "element-ui";

export default {
  // props: ["id","groupName"],
  data() {
    return {
      groupName: this.$route.params.groupName,
      loading: true,
      title: "",
      tabName: "jsgl",
      form_jsgl: {},
      editDialogVisible: false,
      displayFormEdit: false,
      showTable: true,
      other: {
        id: this.$route.params.id
      },
      concatUser: {
        value: ""
      },
      options: [],
      tableData: []
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "username",
          label: "用户名"
        },
        {
          prop: "mobile_phone",
          label: "手机"
        }
        // {
        //   prop: (row, column) => row.oildrum.rfid_number + row.oildrum.imei,
        //   label: "随便"
        // }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable")
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    initData() {
      this.$axiosget("operation/group/users", {
        params: {
          id: this.$route.params.id
        }
      }).then(res => {
        this.tableData = res.data.data.list;
      })
    },
    deleteUser(index, row) {
      var that = this;
      that
        .$confirm("是否解绑该用户", "解绑操作", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          that
            .$axiosdelete("operation/group/deleteUser", {
              params: {
                id: row.id,
                group_id: this.$route.params.id
              }
            })
            .then(res => {
              if (true) {
                that.initData();
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });
              }
            });
        });
    },
    addNew() {
      this.displayFormEdit = true;
      this.concatUser.value = "";
      this.$axiosget("manager/company/getCompanUserListByCompanyId", {
        params: {
          companyId: localStorage.getItem("companyId")
        }
      }).then(res => {
        if (res.data.status === 10000) {
          this.options = res.data.data;
          //console.log(this.options, "options");
        }
      });
    },
    addConcat() {
      this.$refs.concatUser.validate(valid => {
        let obj = {
          user_id: this.concatUser.value,
          group_id: this.$route.params.id
        };
        this.$axiosput("operation/group/addUser", obj)
          .then(res => {
            if (true) {
              this.displayFormEdit = false;
              this.initData();
            } else {
              this.$message.error("该用户已关联");
            }
          })
          .catch(error => {
            this.$message.error("关联失败");
          });
      });
    }
  },
  mounted() {
    this.initData();
  }
};
</script>

<style scoped lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.groupName {
  padding-top: 20px;
  padding-left: 20px;
  font-weight: bold;
  color: #e0edf7;
}
.dialog-footer {
  .confirmConcat {
    width: 80px;
    height: 32px;
    line-height: 32px;
    padding-left: 9px;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 16px;
  }
  .confirmConcat,
  .confirmConcat:hover {
    background: #306ac9 !important;
    border: 0 none;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/system/concatUser.vue